import { getSummaryKeywordFilter } from '@op/services';
import { useEffect, useMemo, useState } from 'react';

export default function useGetFilterKeywordList({
  filter,
  gameInfo, 
}: {
  filter: {
    merge_keywords_list: string[][];
    keywords_list: string[][];
  };
  gameInfo: any; 
}) {
  const [keywordList, setKeywordList] = useState<string[][]>([]);
  const [loading, setLoading] = useState(false);

  function getKeywordList() {
    const { merge_keywords_list, keywords_list } = filter || {};

    if (!merge_keywords_list) {
      setKeywordList(keywords_list || []);
      return;
    }
    if (merge_keywords_list.length === 0) {
      setKeywordList([]);
      return;
    }

    setLoading(true);
    getSummaryKeywordFilter({
      ...gameInfo,
      filter_types: ['merge'],
      keywords_list: merge_keywords_list,
    })
      .then((data: string[][]) => {
        setKeywordList(data || []);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getKeywordList();
  }, [filter]);

  const renderList = useMemo(() => {
    return keywordList?.map?.(item => item.join('+')) || [];
  }, [keywordList]);

  return {
    keywordList,
    loading,
    renderList,
  };
}
